import { useEffect, useRef } from 'react';

export function useComponentMounted(cb: () => void) {
  const iseRequestMade = useRef<boolean>(false);
  useEffect(() => {
    !iseRequestMade.current && cb();
    iseRequestMade.current = true;
  }, []);
}
